import { useParams } from "react-router-dom"
import CouponFormPage from "./CouponFormPage"

export default function CouponEdit() {
    const { id } = useParams()

    return <CouponFormPage mode="edit" couponId={id} />
}
